import { useLocation } from 'react-router';
import { useRunOnce } from '../common/useRunOnce';
import { useMcpConnectorsApiFacade } from '../../apis/facades/useMcpConnectorsApiFacade';
import { telemetry } from '../../telemetry';
import { notifyMcpOAuthCallbackCompleted } from '../dashboard/user-settings/mcp-connectors/mcpOAuthPopupFlow';

const McpOAuthRedirect = () => {
  const { search } = useLocation();
  const { handleOAuthCallback } = useMcpConnectorsApiFacade();

  useRunOnce(async () => {
    const params = new URLSearchParams(search);
    const code = params.get('code');
    const serverId = params.get('state');

    if (code && serverId) {
      try {
        await handleOAuthCallback(serverId, code);
        notifyMcpOAuthCallbackCompleted();
      } catch (error) {
        telemetry.captureError(error);
      }
    }
    window.close();
  });

  return null;
};

export { McpOAuthRedirect };
